
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CourseSignUpIntro extends Vue {
  @Prop() public next!: any;
}
